






























































































    import { Component, Vue, Prop, Emit, Inject, Watch } from 'vue-property-decorator';
    import { CustomField, CustomFieldValue, CustomFieldType, createCustomField, createCustomFieldValue, CustomerType, DtoCustomer, createDtoCustomer } from '../../common/types/AllTypesExports';
    import { TicketFormField, TicketFieldValue } from '../../common/types/attendee-registration/DtoEventAttendeeRegistration';
    import CustomFieldTextEditor from './CustomFieldTextEditor.vue';
    import CustomFieldCheckboxEditor from './CustomFieldCheckboxEditor.vue';
    import CustomFieldNumberEditor from './CustomFieldNumberEditor.vue';
    import CustomFieldSetOfOptionsEditor from './CustomFieldSetOfOptionsEditor.vue';
    import CustomFieldDateTimeEditor from './CustomFieldDateTimeEditor.vue';
    import CustomFieldWebsiteURLEditor from './CustomFieldWebsiteURLEditor.vue';
    import CustomFieldFileUploadEditor from './CustomFieldFileUploadEditor.vue';
    import EventBus from '@/common/services/EventBus';
    import { Attendee, createAttendeeFromSelectListItemWithSubText, DtoAttendee } from '../../common/types/event/DtoAttendee';

    @Component({
        name: 'CustomFieldEditor',
        components: {
            CustomFieldTextEditor,
            CustomFieldCheckboxEditor,
            CustomFieldNumberEditor,
            CustomFieldSetOfOptionsEditor,
            CustomFieldDateTimeEditor,
            CustomFieldWebsiteURLEditor,
            CustomFieldFileUploadEditor
        },
    })
    export default class CustomFieldEditor extends Vue {
        //External
        @Prop({ required: true, default: () => createCustomField() })
        fieldConfig!: CustomField;

        @Prop({ required: false, default: "" })
        idPrefix?: string;

        @Prop({ default: function () { return { value: "", isSummation: false } } })
        value!: CustomFieldValue;

        @Prop()
        columnClass?: string;

        @Prop({ required: false, default: '' })
        validatorScope!: string;

        @Prop({ required: false, default: false })
        disabled!: boolean;

        @Prop({ required: false, default: false })
        hideDisabledMessage!: boolean;

        @Prop({ required: false, default: null })
        isRequired!: boolean;

        @Prop({ required: false, default: CustomerType.Person })
        customerType!: CustomerType;

        @Prop({ required: false, default: () => createDtoCustomer() })
        customer!: DtoCustomer;

        @Prop({ required: false, default: null })
        attendee!: Attendee;

        @Prop({ required: false, default: false })
        isNested!: boolean;

        @Prop({ required: false, default: 0 })
        parentCustomFieldID!: number;

        @Prop({ required: false, default: null })
        parentValue!: string | null;

        @Prop({ required: false, default: () => false })
        isRegistrationEditor!: boolean;

        @Prop({ required: false, default: null })
        ticketFormFields!: TicketFormField[];

        /** When editing event registration, scope dependent fields to this attendee/ticket row (per UniqueRecordID). */
        @Prop({ required: false, default: null })
        registrationRowTicketFieldValue!: TicketFieldValue | null;

        @Inject('validator')
        $validator: any;

        //Internal
        customFieldTypes: object = CustomFieldType;
        hasValueOnLoad: boolean = false;

        //Functions
        created() {
            if (this.isNested) {
                if (this.isRegistrationEditor) {
                    let registrationValue: unknown;
                    if (this.registrationRowTicketFieldValue && this.ticketFormFields) {
                        const ticketFormField = this.ticketFormFields.find(x => x.customFieldID === this.fieldConfig.id);
                        const rowId = this.registrationRowTicketFieldValue.attendeeUniqueRecordId;
                        const tv = ticketFormField?.ticketFieldValues?.find(t => t.attendeeUniqueRecordId === rowId);
                        registrationValue = tv?.customFieldValue?.value ?? tv?.value;
                    } else {
                        registrationValue = this.ticketFormFields
                            ?.find(x => x.customFieldID === this.fieldConfig.id)?.value;
                    }

                    if (typeof registrationValue === 'string') {
                        this.value.value = registrationValue;
                    } else if (registrationValue !== undefined && registrationValue !== null) {
                        this.value.value = registrationValue as never;
                    } else {
                        this.value.value = null;
                    }
                }
            }

            this.value.customFieldId = this.fieldConfig.id;

            // Keep original value for logic below
            const original = this.value ? this.value.value : undefined;

            if (this.fieldConfig.customFieldType === CustomFieldType.Checkbox) {
                // Decide hasValueOnLoad BEFORE setting default
                // Treat only explicit "true" as "had initial value" to avoid locking on default false
                let hadTrue = false;
                if (typeof original === "string") {
                    const s = original.toLowerCase();
                    hadTrue = (s === "true" || s === "1" || s === "yes" || s === "on");
                } else if (typeof original === "boolean") {
                    hadTrue = original === true;
                } else if (typeof original === "number") {
                    hadTrue = original === 1;
                }
                this.hasValueOnLoad = hadTrue;

                // Normalize & set default for checkbox (keep value as string)
                if (original === undefined || original === null || original === "") {
                    this.value.value = "false";
                } else if (typeof original === "string") {
                    const s = original.toLowerCase();
                    this.value.value = (s === "true" || s === "1" || s === "yes" || s === "on") ? "true" : "false";
                } else if (typeof original === "boolean") {
                    this.value.value = original ? "true" : "false";
                } else if (typeof original === "number") {
                    this.value.value = original === 1 ? "true" : "false";
                }
            } else {
                // Non-checkbox: consider non-empty string or any number as "had value"
                if (typeof original === "string" && original.length > 0) {
                    this.hasValueOnLoad = true;
                } else if (typeof original === "number") {
                    this.hasValueOnLoad = true;
                } else {
                    this.hasValueOnLoad = false;
                }
            }

            this.emitInput();

            EventBus.$on("attendee-selector-change", this.emitInput);
        }

        getDependentFieldValue(fieldId: number): CustomFieldValue {
            if (this.isRegistrationEditor && this.registrationRowTicketFieldValue && this.ticketFormFields) {
                const rowId = this.registrationRowTicketFieldValue.attendeeUniqueRecordId;
                const ticketFormField = this.ticketFormFields.find(x => x.customFieldID === fieldId);
                const tv = ticketFormField?.ticketFieldValues?.find(t => t.attendeeUniqueRecordId === rowId);
                if (tv) {
                    if (tv.customFieldValue) {
                        return tv.customFieldValue;
                    }
                    const created = createCustomFieldValue({
                        value: (tv as { value?: unknown }).value,
                        customFieldId: fieldId
                    });
                    this.$set(tv, 'customFieldValue', created);
                    return created;
                }
            }

            if (!this.customer.customFields) {
                this.$set(this.customer, 'customFields', {});
            }

            if (this.customer.customFields[fieldId]) {
                return this.customer.customFields[fieldId];
            }

            const ticketFormField = this.ticketFormFields
                ?.find(x => x.customFieldID === fieldId);

            const existingCustomFieldValue = (ticketFormField as any)?.customFieldValue as CustomFieldValue | undefined;
            if (existingCustomFieldValue) {
                this.$set(this.customer.customFields, fieldId, existingCustomFieldValue);
                return this.customer.customFields[fieldId];
            }

            const newValue = {
                value: typeof ticketFormField?.value === 'string' ? ticketFormField.value : '',
                isSummation: false,
                customFieldId: fieldId
            } as CustomFieldValue;

            this.$set(this.customer.customFields, fieldId, newValue);

            return this.customer.customFields[fieldId];
        }

        setDependentFieldValue(fieldId: number, newValue: CustomFieldValue) {
            if (this.isRegistrationEditor && this.registrationRowTicketFieldValue && this.ticketFormFields) {
                const rowId = this.registrationRowTicketFieldValue.attendeeUniqueRecordId;
                const field = this.ticketFormFields.find(x => x.customFieldID === fieldId);
                const tv = field?.ticketFieldValues?.find(t => t.attendeeUniqueRecordId === rowId);
                if (tv) {
                    const v = newValue?.value ?? null;
                    this.$set(tv as any, 'value', v);
                    if (tv.customFieldValue) {
                        this.$set(tv.customFieldValue, 'value', v);
                    } else {
                        this.$set(tv, 'customFieldValue', createCustomFieldValue({ value: v, customFieldId: fieldId }));
                    }
                }

                if (!this.customer.customFields) {
                    this.$set(this.customer, 'customFields', {});
                }
                this.$set(this.customer.customFields, fieldId, newValue);

                this.emitDependentFieldValueUpdated(fieldId, newValue?.value ?? null);
                return;
            }

            if (!this.customer.customFields) {
                this.$set(this.customer, 'customFields', {});
            }

            this.$set(this.customer.customFields, fieldId, newValue);

            if (this.isRegistrationEditor && this.ticketFormFields) {
                const field = this.ticketFormFields.find(x => x.customFieldID === fieldId);

                if (field) {
                    this.$set(field as any, 'value', newValue?.value ?? null);

                    if ((field as any).customFieldValue) {
                        this.$set((field as any).customFieldValue, 'value', newValue?.value ?? null);
                    }

                    if (Array.isArray(field.ticketFieldValues)) {
                        field.ticketFieldValues.forEach(tv => {
                            this.$set(tv as any, 'value', newValue?.value ?? null);
                            if (tv.customFieldValue) {
                                this.$set(tv.customFieldValue, 'value', newValue?.value ?? null);
                            }
                        });
                    }
                }
            }

            this.emitDependentFieldValueUpdated(fieldId, newValue?.value ?? null);
        }

        @Emit('dependent-field-value-updated')
        emitDependentFieldValueUpdated(customFieldId: number, value: string | null) {
            return {
                customFieldId: customFieldId,
                value: value
            };
        }

        @Emit('input')
        emitInput() {
            if (this.attendee) {
                this.attendee.attendeeCustomFieldValues[this.fieldConfig.id.toString()] = this.value;
            }

            this.$forceUpdate();
            return this.value;
        }

        /** Order nested fields by parent multi-select value sequence, then FieldEdit dependency order, then field display order, then id. */
        sortDependentCustomFields(deps: CustomField[], parentValueRaw: string | null | undefined): CustomField[] {
            if (!deps || deps.length === 0) {
                return deps ?? [];
            }
            const selectedOrder = (typeof parentValueRaw === 'string' ? parentValueRaw : '')
                .split(';')
                .map(s => s.trim())
                .filter(s => s.length > 0);
            const sentinel = 100000;
            const triggerRank = (f: CustomField) => {
                const t = (f.dependentFieldTriggerValue ?? '').trim();
                const idx = selectedOrder.indexOf(t);
                return idx === -1 ? sentinel : idx;
            };
            const dependencyOrder = (f: CustomField) => f.dependencyDisplayOrder ?? 0;
            const fieldDisplayOrder = (f: CustomField) => f.displayOrder ?? 0;
            return [...deps].sort((a, b) => {
                const ra = triggerRank(a);
                const rb = triggerRank(b);
                if (ra !== rb) {
                    return ra - rb;
                }
                const oa = dependencyOrder(a);
                const ob = dependencyOrder(b);
                if (oa !== ob) {
                    return oa - ob;
                }
                const da = fieldDisplayOrder(a);
                const db = fieldDisplayOrder(b);
                if (da !== db) {
                    return da - db;
                }
                return a.id - b.id;
            });
        }

        get readOnly() {
            // Although fieldConfig is currently not used on frontend we are extending the condition so that we prevent any potential problems in the future
            return this.fieldConfig.readOnlyOnFrontend || (this.fieldConfig.readOnlyAfterInitialValue && this.hasValueOnLoad) || this.disabled;
        }

        get computedId() {
            return this.idPrefix + 'CustomField_' + this.fieldConfig.id;
        }

        get dependentFields() {
            const deps = this.fieldConfig.dependentCustomFields;
            const parentRaw = typeof this.value?.value === 'string' ? this.value.value : '';
            return this.sortDependentCustomFields(deps, parentRaw);
        }

        get hasDependentFields() {
            return (this.fieldConfig.dependentCustomFields?.length ?? 0) > 0;
        }

        get showField() {
            if (this.isNested) {
                const parts = (this.parentValue ?? '').split(';').map(s => s.trim()).filter(s => s.length > 0);
                const trigger = (this.fieldConfig.dependentFieldTriggerValue ?? '').trim();
                const hasTriggerValue = parts.includes(trigger);

                if (!hasTriggerValue) {
                    if (this.attendee) {
                        if (this.attendee.attendeeCustomFieldValues[this.fieldConfig.id.toString()]) {
                            this.attendee.attendeeCustomFieldValues[this.fieldConfig.id.toString()].value = '';
                        }
                    }
                    else if (this.customer?.customFields) {
                        this.customer.customFields[this.fieldConfig.id].value = '';
                    }
                }

                return hasTriggerValue;
            } else {
                return true;
            }
        }

        beforeDestroy() {
            EventBus.$off("attendee-selector-change", this.emitInput);
        }
    }
